import { loadable } from '@direct-frontend/modules-render';
import { DelayedSuspense } from '#shared/components/DelayedSuspense';
import { PageStub } from '#shared/components/PageStub';

const ImportUsersFromExcelLazy = loadable(
    () => import(/* webpackChunkName: "ImportUsersFromExcel" */ './ImportUsersFromExcel')
);

export const ImportUsersFromExcelAsync = () => (
    <DelayedSuspense fallback={<PageStub />}>
        <ImportUsersFromExcelLazy />
    </DelayedSuspense>
);
